import { render, staticRenderFns } from "./InfoPhoneModal.vue?vue&type=template&id=46743138&scoped=true&"
import script from "./InfoPhoneModal.vue?vue&type=script&lang=js&"
export * from "./InfoPhoneModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoPhoneModal.vue?vue&type=style&index=0&id=46743138&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46743138",
  null
  
)

export default component.exports